export default {
  state: {
    data: []
  },
  mutations: {
    setBreadcrumb(state, data) {
      state.data = data;
    },
    setBreadcrumbAtIndex(state, { data, index }) {
      const currentData = [...state.data];
      currentData[index] = data;
      state.data = currentData;
    }
  },
  actions: {
    setBreadcrumb({ commit }, data) {
      commit('setBreadcrumb', data);
    },
    setBreadcrumbAtIndex({ commit }, { data, index }) {
      commit('setBreadcrumbAtIndex', { data, index });
    }
  }
};
